export default "__VITE_ASSET__Cpb3T1VH__"